module.exports = __webpack_public_path__ + "static/p_kevin-586c04f80127da000b23ea4e22f1482c.jpg";